import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class BlobService {
  public downloadBlobAsFile(response: Blob, type: string, fileName: string): void {
    const reader = new FileReader();
    reader.readAsArrayBuffer(response);

    reader.onloadend = () => {
      const blob = new Blob([reader.result], { type });
      FileSaver.saveAs(blob, fileName);
    };
  }
}
